import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductService } from '../product.service';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { take } from 'rxjs';
import { IProductDto } from 'src/app/models/backend';
import { ProductType } from 'src/app/models/enums';
import { ControlItem, ProductTypesEnum } from 'src/app/models/frontend';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss']
})
export class EditProductComponent {
  errors: string[] | null = null;
  eventForm:FormGroup
  productType:ControlItem[]=[];
  productImage: File;
  loader=false
  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,
    public productService:ProductService,private toastr:ToastrService) {
    this.LoadCategories()
    this.productType=ProductTypesEnum
  }

  ngOnInit(){
    this.productService.GetProduct(this.productService.id)
    .pipe(take(1))
    .subscribe({
     
     next:r=>this.SetValuetoForm(r),
     error:e => this.errors = e.error?.errors || [e.error?.message]
    })

   
  }

  SetValuetoForm(product:any){
    this.productService.id=null
    console.log(product)
    this.eventForm = this.fb.group({
      Id:[product.id],
      SKU: [product.sku, [Validators.required, Validators.maxLength(100)]],
      ProductName: [product.productName, [Validators.required, Validators.maxLength(100)]],
      Description: [product.description, [Validators.required, Validators.maxLength(100)]],
      DistributorPrice: [product.distributorPrice, [Validators.required, Validators.maxLength(100)]],
      RetailPrice: [product.retailPrice, [Validators.required, Validators.maxLength(100)]],
      Unit: [product.unit, [Validators.required, Validators.maxLength(100)]],
      CategoryId: [product.categoryId],
      TotalStock: [product.totalStock, [Validators.required, Validators.maxLength(10)]],
      StockSold: [product.stockSold, [Validators.required, Validators.maxLength(10)]],
      StockRemaining: [product.stockRemaining, [Validators.required, Validators.maxLength(10)]],
      ProductType:[product.productType],
      ImageUrl:[product.imageUrl]
    });
  }

  onSubmit() {
    this.loader=true
    if (!this.eventForm.valid) {
      this.loader=false
      return this.eventForm.markAllAsTouched();
    }
    console.log(this.eventForm.value.ProductType)
    const productTypeNumber = parseInt(this.eventForm.value.ProductType, 10);
    const productStockRemaining = parseInt(this.eventForm.value.StockRemaining, 10);
    const productStockSold = parseInt(this.eventForm.value.StockSold, 10);
    const productTotalStock = parseInt(this.eventForm.value.TotalStock, 10);
    this.eventForm=this.fb.group({
      id:this.eventForm.value.Id,
      SKU: this.eventForm.value.SKU,
      ProductName: this.eventForm.value.ProductName,
      Description: this.eventForm.value.Description,
      DistributorPrice: this.eventForm.value.DistributorPrice,
      RetailPrice: this.eventForm.value.RetailPrice,
      Unit: this.eventForm.value.Unit,
      CategoryId: this.eventForm.value.CategoryId,
      TotalStock: productTotalStock,
      StockSold: productStockSold,
      StockRemaining:productStockRemaining,
      ProductType:productTypeNumber,
      ImageURL:this.eventForm.value.ImageUrl,
      IsActive:true
    })
    console.log(this.eventForm.value)
   this.productService.updateProduct(this.eventForm.value)
   .subscribe({
    next: r=>{
      // Swal.fire('Updated', '', 'success')
      this.toastr.success('Updated','Success')
      if (this.productImage) this.uploadRafereeImages(r.id);
      this.activeModal.close({ refresh: true });
      this.loader=false
    },
    // error: e => this.errors = e.error?.errors || [e.error?.message]
    error:e=>{
      this.loader=false
      if( e.error?.errors || [e.error?.message])
      {
        this.toastr.error('Oops!', e.error.message);
      }
      else{
        this.toastr.error('Oops!', "Something went wrong");

      }
    }
   })
   
  }
  category:any
  categoryData:ControlItem[]=[]
  
  LoadCategories(){
    this.productService.getActiveCategories().subscribe((res:any)=>{
      this.category=res
      console.log(this.category)
      for(let i=0;i<=this.category.length;i++){
        console.log(this.category[i].categoryName)
        this.categoryData.push({label:this.category[i].categoryName,value:this.category[i].id})
      }
      console.log(this.categoryData)
    })
  }
  uploadRafereeImages(productId: number) {
    if (!productId || !this.productImage) return this.activeModal.close({ refresh: true });

    let myFormData: FormData = new FormData();
    myFormData.append("ProductId", productId.toString());
    myFormData.append("image", this.productImage, this.productImage.name);

    this.productService.uploadProductImage(myFormData).subscribe({
      next: r => {
        console.log("Image Uploaded ", r);
      },
      error: e => console.log("Image Failed to Upload ", e)
    })
  }
  setUserOrPassportImage($event: any) {
    const target = $event.target as HTMLInputElement;
    const files = target.files as FileList;
    const file = files[0];
    this.productImage = file;
  }
}
